import type * as C from "@zooi/contracts";

/** Library rules are shown once in every channel where they apply. */
export function rulesByChannel<T extends { id: string; channels: string[] }>(rules: T[]) {
  const channels = [...new Set(rules.flatMap((rule) => rule.channels))].sort();
  return channels.map((channel) => ({ channel, rules: rules.filter((rule) => rule.channels.includes(channel)) }));
}

/** Channel rules as shown: zooi's platform rules and defaults, then the workspace's own active policies. */
export function channelRules(policies: C.KnowledgeViewT["policies"], workspace: C.WorkspacePolicy[]) {
  return [
    ...policies.filter((policy) => policy.kind !== "workspace_policy").map((policy) => ({ ...policy, required: policy.kind === "platform_rule" })),
    ...workspace.filter((policy) => policy.active).map((policy) => ({ id: policy.id, kind: "workspace_policy" as const, rule: policy.rule, channels: policy.channels, required: true, enforcement: policy.enforcement, source: null, verification: null, checked_at: null, why: null, talking_points: [] })),
  ];
}

/** A product remembered on this device must still belong to this workspace. */
export function libraryProductId(products: Pick<C.Product, "id">[], selected: string | null, remembered: string | null) {
  const candidate = selected ?? remembered;
  return candidate && products.some((product) => product.id === candidate) ? candidate : "";
}

/** Method references are content, but only public HTTP links can be opened. */
export function methodSourceUrl(source: string) {
  try {
    const url = new URL(source);
    return ["https:", "http:"].includes(url.protocol) && !url.username && !url.password ? url.href : null;
  } catch {
    return null;
  }
}
